import logo from '../../assets/images/logo22.png';
import {
  ForgotDiv,
  Warper,
  Logo,
  Title,
  FomrDiv,
  Label,
  ForgotPasswordImg,
} from './ForgotPassword.style';
import { useForm, Controller } from 'react-hook-form';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { useAppDispatch, useAppSelector } from '../../core/hooks';
import { loadingSelector, setLoading } from '../../features/loading/loadingSlice';
import axiosInstance from '../../core/axiosInstance';
import { useNavigate } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import img from './../../assets/images/loginbg.png';
import { InputText } from 'primereact/inputtext';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import './ForgotPassword.css';
import foreign from './../../assets/images/foriegnlogo.png';
import { classNames } from 'primereact/utils';

const ResetPassword = () => {
  useEffect(() => {
    axiosInstance
      .get('/check-expired')
      .then()
      .catch((err) => {
        if (err.response.status === 400 && !err.response.license) {
          toast.error(err.response.data.message, {
            position: toast.POSITION.TOP_CENTER,
            toastId: 'uniqueId',
          });
          window.location.replace(window.location.origin + '/expired');
        }
      });
  }, []);
  const defaultValues = {
    generated_key: '',
    new_password: '',
    new_password_confirmation: '',
    email: localStorage.getItem('email'),
  };

  //selectors
  const isLoading = useAppSelector(loadingSelector);
  const {
    control,
    formState: { errors },
    reset,
    handleSubmit,
  } = useForm({ defaultValues });

  //store actions to store creadentials to the store
  const dispatch = useAppDispatch();

  //navigator to navigate to home if login sucess
  const navigate = useNavigate();
  const getFormErrorMessage = (name: string) => {
    return (
      //@ts-ignore
      errors[`${name}`] && (
        <small className="p-error">
          {/* @ts-ignore */}
          {errors ? errors[`${name}`]?.message : null}
        </small>
      )
    );
  };
  const onSubmit = async (data: any) => {
    dispatch(setLoading(true));
    if (data.password === data.confirmPassword) {
      await axiosInstance
        .post<any>('/dashboard/reset-the-password', data)
        .then((res) => {
          dispatch(setLoading(false));
          if (res.data?.message) {
            toast.success(res.data?.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
          localStorage.removeItem('email');
          navigate('/login');
        })
        .catch((err: any) => {
          dispatch(setLoading(false));
          if (err.response.data.errors?.generated_key) {
            toast.error('Invalid Key', {
              position: toast.POSITION.TOP_CENTER,
            });
          } else if (err.response.data.errors?.new_password) {
            toast.error('Password and Password Confirmation Must Match', {
              position: toast.POSITION.TOP_CENTER,
            });
          } else {
            toast.error(err.response.data.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        });
    } else {
      dispatch(setLoading(false));
    }
  };

  return (
    <Warper>
      <ForgotDiv>
        <div className="formContainer reset-div">
          <Logo src={logo} alt="logo" className="resetpass-logo" />
          <FomrDiv>
            <Title>Set A New Password</Title>
            <div className="" style={{ position: 'relative', minWidth: '100%' }}>
              <div className="card">
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
                  <div className="p-field">
                    <Label
                      className={classNames({
                        'p-error': errors[`generated_key`],
                      })}
                      htmlFor="generated_key"
                    >
                      Key
                    </Label>
                    <Controller
                      name="generated_key"
                      control={control}
                      rules={{
                        required: '*Required',
                        minLength: {
                          value: 5,
                          message: 'Enter at least 5 digits',
                        },
                      }}
                      render={({ field, fieldState }) => (
                        <InputText
                          type="text"
                          disabled={isLoading ? true : false}
                          id={field.name}
                          {...field}
                          placeholder="A key has been sent to your email"
                          style={{ color: '#616161', opacity: '0.71' }}
                          className={classNames({
                            'p-invalid': fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage('generated_key')}
                  </div>
                  <div className="p-field">
                    <Label
                      className={classNames({
                        'p-error': errors[`new_password`],
                      })}
                      htmlFor="new_password"
                    >
                      New Password
                    </Label>
                    <Controller
                      name="new_password"
                      control={control}
                      rules={{
                        required: '*Required',
                        minLength: {
                          value: 6,
                          message: 'Enter at least 6 digits',
                        },
                      }}
                      render={({ field, fieldState }) => (
                        <Password
                          disabled={isLoading ? true : false}
                          id={field.name}
                          {...field}
                          placeholder="New Password"
                          toggleMask
                          className={classNames({
                            'p-invalid': fieldState.invalid,
                          })}
                          style={{ color: '#616161', opacity: '0.71' }}
                        />
                      )}
                    />
                    {getFormErrorMessage('new_password')}
                  </div>

                  <div className="p-field">
                    <Label
                      className={classNames({
                        'p-error': errors[`new_password_confirmation`],
                      })}
                      htmlFor="new_password_confirmation"
                    >
                      Confirm New Password
                    </Label>
                    <Controller
                      name="new_password_confirmation"
                      control={control}
                      rules={{
                        required: '*Required',
                        minLength: {
                          value: 6,
                          message: 'Enter at least 6 digits',
                        },
                      }}
                      render={({ field, fieldState }) => (
                        <Password
                          style={{ color: '#616161', opacity: '0.71' }}
                          disabled={isLoading ? true : false}
                          id={field.name}
                          {...field}
                          className={classNames({
                            'p-invalid': fieldState.invalid,
                          })}
                          placeholder="Confirm New Password"
                          toggleMask
                        />
                      )}
                    />
                    {getFormErrorMessage('new_password_confirmation')}
                  </div>

                  <Button
                    type="submit"
                    label="Save Changes"
                    className="p-mt-2 submit-btn"
                    disabled={isLoading ? true : false}
                  ></Button>
                </form>
              </div>
            </div>
          </FomrDiv>
        </div>
        <div className="for-logo">
          <img src={foreign} style={{ width: '8%' }} alt="logo" />
          <img src={foreign} style={{ width: '8%' }} alt="logo" />
        </div>
      </ForgotDiv>
      <ForgotPasswordImg>
        <img src={img} alt="" />
      </ForgotPasswordImg>
    </Warper>
  );
};

export default ResetPassword;
